// extracted by mini-css-extract-plugin
export default {"modal":"warning_modal__2BLAI","modalContent":"warning_modalContent__ikxno"};